import React, { useEffect, useRef, useState } from 'react';
import { TypeaheadSearchResultItem } from './typeaheadSearchResult';

export interface TypeaheadSearchResultListItemProps {
  id: string;
  resultItem: TypeaheadSearchResultItem;
  multiSelect?: boolean;
  selected?: boolean;
  marked?: boolean;
  onItemClick?: Function;
  multiSelectChange: Function;
}

const TypeaheadSearchResultListItem = ({
  id,
  multiSelect,
  resultItem,
  marked,
  selected,
  onItemClick,
  multiSelectChange,
}: TypeaheadSearchResultListItemProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (selected !== undefined) {
      setChecked(selected);
      multiSelectChange(resultItem, selected);
    }
  }, [selected]);

  const checkItem = (e: any) => {
    if (checked) {
      setChecked(false);
      multiSelectChange(resultItem, false);
      // resultItem.selected = false;
    } else {
      setChecked(true);
      multiSelectChange(resultItem, true);
      //resultItem.selected = true;
    }
  };

  // --------------------------------------------------------------------------------------------------
  // JSX
  // --------------------------------------------------------------------------------------------------

  return multiSelect ? (
    <div className="typeahead-search-result-multi-select-item">
      <input id={id} type="checkbox" onChange={checkItem} checked={checked} />
      <label htmlFor={id}> {resultItem.label}</label>
    </div>
  ) : (
    <button
      type="button"
      onClick={() => onItemClick && onItemClick(resultItem)}
      className={`typeahead-search-result-list-item ${marked ? 'active' : ''}`}
    >
      {resultItem.label}
    </button>
  );
};

export default TypeaheadSearchResultListItem;
